import { api } from '@/lib/api';
import type {
  ActiveUsers,
  TrendDataPoint,
  UserActivity,
  ActionBreakdown,
  ModuleUsage,
  AiUserUsage,
} from '../types/analytics.types';

export const analyticsService = {
  async getActiveUsers(): Promise<ActiveUsers> {
    const { data } = await api.get<ActiveUsers>('/core/analytics/active-users');
    return data;
  },

  async getConnectionTrends(
    days: number = 30,
    granularity: 'day' | 'week' = 'day',
  ): Promise<TrendDataPoint[]> {
    const { data } = await api.get<TrendDataPoint[]>('/core/analytics/connection-trends', {
      params: { days, granularity },
    });
    return data;
  },

  async getTopUsers(days: number = 30, limit: number = 10): Promise<UserActivity[]> {
    const { data } = await api.get<UserActivity[]>('/core/analytics/top-users', {
      params: { days, limit },
    });
    return data;
  },

  async getActionsBreakdown(days: number = 30): Promise<ActionBreakdown> {
    const { data } = await api.get<ActionBreakdown>('/core/analytics/actions-breakdown', {
      params: { days },
    });
    return data;
  },

  async getModuleUsage(days: number = 30): Promise<ModuleUsage> {
    const { data } = await api.get<ModuleUsage>('/core/analytics/module-usage', {
      params: { days },
    });
    return data;
  },

  async getAiUsagePerUser(days: number = 30): Promise<AiUserUsage[]> {
    const { data } = await api.get<AiUserUsage[]>('/core/analytics/ai-usage-per-user', {
      params: { days },
    });
    return data;
  },

  async getUsersActivity(): Promise<UserActivity[]> {
    const { data } = await api.get<UserActivity[]>('/core/analytics/users-activity');
    return data;
  },
};
